import "./main.css";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var $ea2e8e3460b67692$exports = {};

$parcel$export($ea2e8e3460b67692$exports, "spectrum--darkest", () => $ea2e8e3460b67692$export$4ecdba604f5f1f44, (v) => $ea2e8e3460b67692$export$4ecdba604f5f1f44 = v);
var $ea2e8e3460b67692$export$4ecdba604f5f1f44;
$ea2e8e3460b67692$export$4ecdba604f5f1f44 = `gP7gvq_spectrum--darkest`;


var $5b6ea5874ed9af7b$exports = {};

$parcel$export($5b6ea5874ed9af7b$exports, "spectrum", () => $5b6ea5874ed9af7b$export$3311ab3a441bc141, (v) => $5b6ea5874ed9af7b$export$3311ab3a441bc141 = v);
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum--dark", () => $5b6ea5874ed9af7b$export$68dc111a79481afd, (v) => $5b6ea5874ed9af7b$export$68dc111a79481afd = v);
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum--darkest", () => $5b6ea5874ed9af7b$export$4ecdba604f5f1f44, (v) => $5b6ea5874ed9af7b$export$4ecdba604f5f1f44 = v);
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum--large", () => $5b6ea5874ed9af7b$export$a88a8dbe29386d31, (v) => $5b6ea5874ed9af7b$export$a88a8dbe29386d31 = v);
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum--light", () => $5b6ea5874ed9af7b$export$efb37c2f79da8163, (v) => $5b6ea5874ed9af7b$export$efb37c2f79da8163 = v);
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum--lightest", () => $5b6ea5874ed9af7b$export$baaa804dc80cce18, (v) => $5b6ea5874ed9af7b$export$baaa804dc80cce18 = v);
$parcel$export($5b6ea5874ed9af7b$exports, "spectrum--medium", () => $5b6ea5874ed9af7b$export$4c0c83b3f4303ef8, (v) => $5b6ea5874ed9af7b$export$4c0c83b3f4303ef8 = v);
var $5b6ea5874ed9af7b$export$3311ab3a441bc141;
var $5b6ea5874ed9af7b$export$68dc111a79481afd;
var $5b6ea5874ed9af7b$export$4ecdba604f5f1f44;
var $5b6ea5874ed9af7b$export$a88a8dbe29386d31;
var $5b6ea5874ed9af7b$export$efb37c2f79da8163;
var $5b6ea5874ed9af7b$export$baaa804dc80cce18;
var $5b6ea5874ed9af7b$export$4c0c83b3f4303ef8;
$5b6ea5874ed9af7b$export$3311ab3a441bc141 = `zA6MfG_spectrum`;
$5b6ea5874ed9af7b$export$68dc111a79481afd = `zA6MfG_spectrum--dark`;
$5b6ea5874ed9af7b$export$4ecdba604f5f1f44 = `zA6MfG_spectrum--darkest`;
$5b6ea5874ed9af7b$export$a88a8dbe29386d31 = `zA6MfG_spectrum--large`;
$5b6ea5874ed9af7b$export$efb37c2f79da8163 = `zA6MfG_spectrum--light`;
$5b6ea5874ed9af7b$export$baaa804dc80cce18 = `zA6MfG_spectrum--lightest`;
$5b6ea5874ed9af7b$export$4c0c83b3f4303ef8 = `zA6MfG_spectrum--medium`;


var $b2eefcc3e5fdb373$exports = {};

$parcel$export($b2eefcc3e5fdb373$exports, "spectrum--large", () => $b2eefcc3e5fdb373$export$a88a8dbe29386d31, (v) => $b2eefcc3e5fdb373$export$a88a8dbe29386d31 = v);
var $b2eefcc3e5fdb373$export$a88a8dbe29386d31;
$b2eefcc3e5fdb373$export$a88a8dbe29386d31 = `HAZavG_spectrum--large`;


var $729ae839c55d8d77$exports = {};

$parcel$export($729ae839c55d8d77$exports, "spectrum--light", () => $729ae839c55d8d77$export$efb37c2f79da8163, (v) => $729ae839c55d8d77$export$efb37c2f79da8163 = v);
var $729ae839c55d8d77$export$efb37c2f79da8163;
$729ae839c55d8d77$export$efb37c2f79da8163 = `PFjRbG_spectrum--light`;


var $b4d117254fac085c$exports = {};

$parcel$export($b4d117254fac085c$exports, "spectrum--medium", () => $b4d117254fac085c$export$4c0c83b3f4303ef8, (v) => $b4d117254fac085c$export$4c0c83b3f4303ef8 = v);
var $b4d117254fac085c$export$4c0c83b3f4303ef8;
$b4d117254fac085c$export$4c0c83b3f4303ef8 = `xSyFOq_spectrum--medium`;


let $bf24a13e98395dd3$export$bca14c5b3b88a9c9 = {
    global: (/*@__PURE__*/$parcel$interopDefault($5b6ea5874ed9af7b$exports)),
    light: (/*@__PURE__*/$parcel$interopDefault($729ae839c55d8d77$exports)),
    dark: (0, (/*@__PURE__*/$parcel$interopDefault($ea2e8e3460b67692$exports))),
    medium: (/*@__PURE__*/$parcel$interopDefault($b4d117254fac085c$exports)),
    large: (/*@__PURE__*/$parcel$interopDefault($b2eefcc3e5fdb373$exports))
};


export {$bf24a13e98395dd3$export$bca14c5b3b88a9c9 as theme};
//# sourceMappingURL=module.js.map
